import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Button
} from "@mui/material";
import { DEFAULT_DATE_FORMAT } from "config";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";
import { RxCross2 } from "react-icons/rx";
import CustomTabs from "components/CustomTabs";
import DocumentManagement from "components/DocumentManagement";
import CustomTable from "components/grid/CustomTable";
import ViewActionTracker from "view/actionTracker/ViewActionTracker";

const tabs = ["SITC Information", "Documents"];
const getStatusColor = (data) => {
    if (!data) return "purple";

    const status = (data.status || "").toLowerCase();
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);


    // Case 1: In Progress & overdue
    if (status === "in progress" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }

    // Case 2: In Progress & future due date
    if (status === "in progress" && dueDate && dueDate >= today) {
        return { bg: "orange", text: "white" };
    }

    // Case 3: Completed or Closed
    if (status === "completed" || status === "closed") {
        return { bg: "#E1FFBB", text: "#34A853" };
    }

    // Default
    return "purple";
};
const ViewSitcTracker = (props) => {
    const { open, handleClose, rowData, isLoading, subTabValue, canceltabValue, tabLength } = props;
    const [tabValue, setTabValue] = useState(0);

    //action item related
    const [selectedAction, setSelectedAction] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const handleViewAction = (action) => {
        setSelectedAction(action);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedAction(null);
    };
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const formatCurrency = (value) => {
        if (!value && value !== 0) return "N/A";
        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    };

    const formatDate = (date) => {
        return date ? moment(date).format("DD MMM YYYY") : "N/A";
    };

    const columns = (onView) => [
        {
            name: "ID",
            field: "customId",
            width: "50px"
        },
        {
            name: "Description",
            field: "description",
            width: "200px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {row?.description}
                </Box>
            ),
        },
        {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Assignee",
            field: "assignee",
            // width: "25%",
            renderer: (row) => (
                <>
                    {row?.assignedTo?.split(',')?.map((val, key) => (
                        <Typography key={key} sx={{ fontSize: "16px", fontWeight: 500, color: "#433F5E" }}>
                            {val}
                        </Typography>
                    ))}
                </>
            ),
        },
        {
            name: "Due Date",
            field: 'dueDate',
            renderer: (row) => (
                <>
                    {row?.revisedDueDate ?
                        <>
                            <Chip
                                label={moment.utc(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                sx={{
                                    textDecoration: "line-through",
                                    color: "#e51c1cff",
                                    backgroundColor: "#f5ccccff",
                                    fontWeight: 500,
                                    height: "20px",
                                    borderRadius: "5px",
                                    padding: "2px 6px",
                                    fontFamily: "Outfit",
                                    fontSize: "12px",
                                    marginRight: "5px",
                                }}
                            />
                            {row?.revisedDueDateHistory?.map((val, ind, arr) => {
                                const isLast = ind === arr.length - 1;
                                return (
                                    <Chip
                                        key={ind}
                                        label={moment(val).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            textDecoration: isLast ? "none" : "line-through",
                                            color: isLast ? "#34A853" : "#e51c1cff",
                                            backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "5px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                );
                            })}
                        </>
                        :
                        <>
                            {moment(row?.dueDate).isValid() ?
                                <Chip
                                    label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                    sx={{
                                        // textDecoration: "line-through",
                                        color: getStatusColor(row).text,
                                        backgroundColor: getStatusColor(row).bg,
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "5px",
                                        padding: "2px 6px",
                                        fontFamily: "Outfit",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                : '-'
                            }
                        </>
                    }
                </>
            ),
        },
        {
            name: "",
            field: "",
            renderer: (row) => (
                <Button onClick={() => onView(row)}>
                    View
                </Button>
            ),
        },
    ];
    const renderSubTab0Fields = () => (
        <>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Budgeted Cost (In INR):</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatCurrency(rowData?.budgetedCost)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Actual Cost (In INR):</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatCurrency(rowData?.actualCost)}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Legal Entity:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.legalEntity ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Source Department:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.sourceDepartment ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Procurement Owner:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.procurementOwner ?? "N/A"}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Vendor Name:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.vendorName ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>LOI Reference:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.loiReference ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Planned Date For Service Request:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.plannedDateForServiceRequest)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Actual Service Request/Indent Date:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.actualServiceRequestIndentDate)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Planned Date RFP/RFQ Floating:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.plannedRfpRfqFloatingDate)}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Actual LOI/WO Date:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.actualLoiWoDate)}
                </Typography>
            </Grid>

            {/* <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Cutoff Date For Receipt Of Bids:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.bidReceiptCutoffDate)}
                </Typography>
            </Grid> */}

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Planned Date Of Release Of LOI/WO/PO:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.plannedLoiReleaseDate)}
                </Typography>
            </Grid>


            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Planned Finish Of The Activity At Site:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.plannedFinishAtSiteDate)}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Planned Start Of The Activity At Site:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.plannedStartAtSiteDate)}
                </Typography>
            </Grid>


            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong> Tender Package Release Date:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.tenderPackageReleaseDate)}
                </Typography>
            </Grid>

            {/* <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Lead Time (Days):</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.leadTimeDays ?? "N/A"}
                </Typography>
            </Grid> */}

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Mobilization Required Days Left:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.mobilizationRequiredDaysLeft ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Last Updated Date:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.lastUpdatedDate)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Status:</strong>
                </Typography>
                <Typography
                    sx={valueStyle}
                >
                    {rowData?.status ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography sx={labelStyle}>
                    <strong>Package Description:</strong>
                </Typography>
                <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#111827",
                        fontWeight: 500,
                        mb: 2,
                        fontFamily: "Outfit, sans-serif",
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        borderLeft: "4px solid #0E73F6",
                        minHeight: "60px",
                        lineHeight: "1.5",
                    }}
                >
                    {rowData?.packageDescription ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography sx={labelStyle}>
                    <strong>Scope Summary:</strong>
                </Typography>
                <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#111827",
                        fontWeight: 500,
                        mb: 2,
                        fontFamily: "Outfit, sans-serif",
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        borderLeft: "4px solid #0E73F6",
                        minHeight: "60px",
                        lineHeight: "1.5",
                    }}
                >
                    {rowData?.scopeSummary ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography sx={labelStyle}>
                    <strong>Remarks / Notes:</strong>
                </Typography>
                <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#111827",
                        fontWeight: 500,
                        mb: 2,
                        fontFamily: "Outfit, sans-serif",
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        borderLeft: "4px solid #0E73F6",
                        minHeight: "60px",
                        lineHeight: "1.5",
                    }}
                >
                    {rowData?.remark ?? "N/A"}
                </Typography>
            </Grid>
        </>
    );

    const renderSubTab1Fields = () => (
        <>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Sub Project:</strong>
                </Typography>
                <Typography sx={valueStyle}>{rowData?.subProject ?? "N/A"}</Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Service Category:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.serviceCategory ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Procurement Method:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.procurementMethod ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography sx={labelStyle}>
                    <strong>Package Description:</strong>
                </Typography>
                <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#111827",
                        fontWeight: 500,
                        mb: 2,
                        fontFamily: "Outfit, sans-serif",
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        borderLeft: "4px solid #0E73F6",
                        minHeight: "60px",
                        lineHeight: "1.5",
                    }}
                >
                    {rowData?.packageDescription ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography sx={labelStyle}>
                    <strong>Scope Summary:</strong>
                </Typography>
                <Typography
                    sx={{
                        fontSize: "16px",
                        color: "#111827",
                        fontWeight: 500,
                        mb: 2,
                        fontFamily: "Outfit, sans-serif",
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        borderLeft: "4px solid #0E73F6",
                        minHeight: "60px",
                        lineHeight: "1.5",
                    }}
                >
                    {rowData?.scopeSummary ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>RFP/RFQ Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.rfpRfqDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>RFP/RFQ Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.rfpRfqPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>RFP/RFQ Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.rfpRfqActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>NIT Issue Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.nitIssueDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>NIT Issue Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.nitIssuePlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>NIT Issue Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.nitIssueActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Bid Invitation Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.bidInvitationDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Bid Invitation Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.bidInvitationPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Bid Invitation Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.bidInvitationActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Pre-Bid Meeting Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.preBidMeetingDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Pre-Bid Meeting Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.preBidMeetingPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Pre-Bid Meeting Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.preBidMeetingActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Bid Submission Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.bidSubmissionDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Bid Submission Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.bidSubmissionPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Bid Submission Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.bidSubmissionActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Technical Evaluation Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.technicalEvaluationDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Technical Evaluation Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.technicalEvaluationPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Technical Evaluation Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.technicalEvaluationActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Commercial Evaluation Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.commercialEvaluationDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Commercial Evaluation Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.commercialEvaluationPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Commercial Evaluation Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.commercialEvaluationActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Negotiation Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.negotiationDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Negotiation Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.negotiationPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Negotiation Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.negotiationActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Approval Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.approvalDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Approval Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.approvalPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Approval Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.approvalActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>PO/LOA Issue Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.poLoaIssueDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>PO/LOA Issue Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.poLoaIssuePlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>PO/LOA Issue Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.poLoaIssueActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Mobilization Days:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {rowData?.mobilizationDays ?? "N/A"}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Mobilization Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.mobilizationPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Mobilization Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.mobilizationActual)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Completion Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.completionPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Completion Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.completionActual)}
                </Typography>
            </Grid>

            {/* <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Closeout Planned:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.closeoutPlanned)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Typography sx={labelStyle}>
                    <strong>Closeout Actual:</strong>
                </Typography>
                <Typography sx={valueStyle}>
                    {formatDate(rowData?.closeoutActual)}
                </Typography>
            </Grid> */}
        </>
    );

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden",
                    maxHeight: "90vh",
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                    position: "relative",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: "27px",
                            lineHeight: "100%",
                            color: "#140F36",
                            fontFamily: "Outfit, sans-serif",
                        }}
                    >
                        View SITC Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    {/* <CustomTabs tabValue={tabValue} handleTabChange={handleTabChange} tabs={tabs} /> */}
                    {tabValue === 0 && (
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: "20px",
                                            fontFamily: "Outfit, sans-serif",
                                            color: "#0A0A0C",
                                        }}
                                    >
                                        SITC Information
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 3 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ xs: 12 }}>
                                            <Grid container spacing={1}>
                                                {(subTabValue === "summary" || canceltabValue === tabLength) && renderSubTab0Fields()}
                                                {subTabValue === "detail" && renderSubTab1Fields()}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <Card
                                    elevation={0}
                                    sx={{
                                        borderRadius: "3px",
                                        border: "1px solid #e5e7eb",
                                        backgroundColor: "#fff",
                                        p: 2,
                                        mt: 1
                                    }}
                                >
                                    {/* Header */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 1,
                                        }}
                                    >
                                        <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                            Procurement Action Item
                                        </Typography>
                                    </Box>

                                    <Divider sx={{ mb: 2 }} />

                                    <CardContent sx={{ pt: 0 }}>
                                        <Grid container spacing={2}>
                                            <Grid size={{ md: 12 }}>
                                                {/* data is dummy pls remove */}
                                                {/* <CustomTable columns={columns} data={[{
                                        description: '1. Maintain close coordination and regular communication with the Authority to monitor land acquisition progress. 2. Obtain early and clear timelines from the Authority for land handover and incorporate contingencies in the project schedule. 3. Plan phased construction activities to optimize progress on available land parcels',
                                        status:'Open',
                                        assignedTo:'Ashok'
                                    }]} /> */}
                                                <CustomTable columns={columns(handleViewAction)} data={rowData?.projectActions || []} />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                    <ViewActionTracker
                                        open={isDialogOpen}
                                        handleClose={handleCloseDialog}
                                        rowData={selectedAction}  // or actionId={selectedAction?.id}
                                    />

                                </Card>
                            </Card>
                        </Grid>
                    )}

                    {/* {tabValue === 1 && (
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={rowData?.id} entityType="SITC" customId={rowData?.customId} isView={true} />
                        </Grid>
                    )} */}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ViewSitcTracker;